import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ReactComponent as CoinIcon } from 'assets/images/Auto-Coin.svg';
import { useAppContext } from 'components/AppContext';
import { useToastContext } from 'auto-design-common';
import * as api from 'utils/api';
import useTranslation from '../../hooks/useTranslation';

export default function PurchaseExtraRender({
  onDone,
  onClose,
  imageId,
}) {
  const [submitting, setSubmitting] = useState(false);
  const { tPurchaseExtraRender, tCommon } = useTranslation();
  const { request, configs } = useAppContext();
  const { toastError } = useToastContext();

  const purchase = async () => {
    const { success, error } = await request(api.purchaseExtraRender(imageId));

    if (success) {
      onDone();
      onClose();
    } else {
      toastError(error);
    }

    setSubmitting(false);
  };

  return (
    <Modal
      show
      backdrop="static"
      id="modal-delete-location"
      size="md"
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {tPurchaseExtraRender('title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {tPurchaseExtraRender('description')}
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={submitting}
          variant="secondary"
          onClick={onClose}
        >
          {tCommon('cancel')}
        </Button>
        <Button
          disabled={submitting}
          variant="danger"
          onClick={async () => {
            setSubmitting(true);
            await purchase();
          }}
        >
          {tPurchaseExtraRender('pay')}
          {' '}
          {configs.extra_render_price}
          {' x '}
          <CoinIcon />
        </Button>

      </Modal.Footer>
    </Modal>
  );
}
